import { useMutation, useQueryClient } from "@tanstack/react-query";
import OnlineOrderPopupValues from "../../../models/formModels/onlineOrderPopupValues.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import moment from "moment";
import toastMessages from "../../helpers/toastMessage";
import CreatePatientPayload from "../../../models/API/requestModels/createPatientPayload.model";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import OrganizationDetailModel from "../../../models/API/responseModels/organizationDetailResponse.model";

function useCreatePatient(oktaAuth?: any) {
  const {
    state: { selectedOrganization },
  } = useContext(ApplicationState);
  const authState = useOktaAuth()?.authState ?? oktaAuth?.authState;
  const queryClient = useQueryClient();
  const organizations: any = queryClient.getQueryData(["organizations"]);

  const foundOrganization = organizations?.data?.find(
    (org: OrganizationDetailModel) => org.id === selectedOrganization
  );

  return useMutation({
    mutationKey: ["createPatient"],
    mutationFn: (data: OnlineOrderPopupValues) => {
      const payload: CreatePatientPayload = {
        reference: foundOrganization
          ? foundOrganization.fhirOrganizationId
          : "",
        firstName: data.firstName,
        lastName: data.lastName,
        middleInitial: data.middleInitial,
        email: data.email,
        gender: data.gender,
        birthDate: moment(data.birthDate).format("MM-DD-YYYY"),
        ssn: data.securityInfo.ssn,
        mrn: data.securityInfo.mrn,
        city: data.city,
        state: data.state,
        phone: data.phone,
        address: data.address,
        zipcode: data.zipcode,
      };

      return axiosInstance
        .post(`/v1/patients`, payload, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data);
    },
    onError: (error: any) => {
      let errorMessage = error.response.data.message ?? error.message;
      toastMessages.error(errorMessage);
    },
    onSuccess: () => {
      toastMessages.success("Patient created successfully!");
      queryClient.refetchQueries({
        queryKey: ["patientsList", { organizationId: selectedOrganization }],
      });
    },
  });
}
export default useCreatePatient;
